var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 15.2067C7.53998 15.2067 7.10665 14.9733 6.79998 14.5667L5.79998 13.2333C5.77998 13.2067 5.69998 13.1733 5.66665 13.1667H5.33331C2.55331 13.1667 0.833313 12.4133 0.833313 8.66668V5.33334C0.833313 2.38668 2.38665 0.833344 5.33331 0.833344H10.6666C13.6133 0.833344 15.1666 2.38668 15.1666 5.33334V8.66668C15.1666 11.6133 13.6133 13.1667 10.6666 13.1667H10.3333C10.28 13.1667 10.2333 13.1933 10.2 13.2333L9.19998 14.5667C8.89331 14.9733 8.45998 15.2067 7.99998 15.2067ZM5.33331 1.83334C2.94665 1.83334 1.83331 2.94668 1.83331 5.33334V8.66668C1.83331 11.68 2.86665 12.1667 5.33331 12.1667H5.66665C6.00665 12.1667 6.39331 12.36 6.59998 12.6333L7.59998 13.9667C7.83331 14.2733 8.16665 14.2733 8.39998 13.9667L9.39998 12.6333C9.61998 12.34 9.96665 12.1667 10.3333 12.1667H10.6666C13.0533 12.1667 14.1666 11.0533 14.1666 8.66668V5.33334C14.1666 2.94668 13.0533 1.83334 10.6666 1.83334H5.33331Z",
    fill: "#56585E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 8.00001C7.62665 8.00001 7.33331 7.70001 7.33331 7.33334C7.33331 6.96667 7.63331 6.66667 7.99998 6.66667C8.36665 6.66667 8.66665 6.96667 8.66665 7.33334C8.66665 7.70001 8.37331 8.00001 7.99998 8.00001Z",
    fill: "#56585E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8.00001C10.2933 8.00001 10 7.70001 10 7.33334C10 6.96667 10.3 6.66667 10.6667 6.66667C11.0333 6.66667 11.3333 6.96667 11.3333 7.33334C11.3333 7.70001 11.04 8.00001 10.6667 8.00001Z",
    fill: "#56585E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33335 8.00001C4.96002 8.00001 4.66669 7.70001 4.66669 7.33334C4.66669 6.96667 4.96669 6.66667 5.33335 6.66667C5.70002 6.66667 6.00002 6.96667 6.00002 7.33334C6.00002 7.70001 5.70669 8.00001 5.33335 8.00001Z",
    fill: "#56585E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.e4ef4fdf24cf3b8458efe3dd83349d19.svg";
export { ForwardRef as ReactComponent };